const FEATURES = [
  {
    testid: "feature-card-unattended",
    image:
      "https://images.unsplash.com/photo-1629131726692-1accd0c53ce0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxsYXB0b3AlMjBjbG9zZWR8ZW58MHx8fHwxNzkyNDE4MDU3fDA&ixlib=rb-4.1.0&q=85",
    alt: "Laptop closed while background cloud container executes tasks",
    iconColor: "text-[#22d3ee]",
    icon: (
      <>
        <rect x="2" y="3" width="20" height="14" rx="2"></rect>
        <line x1="8" y1="21" x2="16" y2="21"></line>
        <line x1="12" y1="17" x2="12" y2="21"></line>
      </>
    ),
    title: "Unattended Execution",
    body: "Close your lid. Agents execute multi-hour tasks autonomously in the cloud.",
  },
  {
    testid: "feature-card-zero-config",
    image:
      "https://images.pexels.com/photos/17489151/pexels-photo-17489151.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Instant spin-up of an isolated container execution environment",
    iconColor: "text-[#a855f7]",
    icon: (
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
    ),
    title: "Zero Configuration",
    body: "Fresh Ubuntu and Alpine boxes created in under 300 milliseconds.",
  },
  {
    testid: "feature-card-billing",
    image:
      "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxydW50aW1lJTIwbWV0ZXIlMjBkYXNoYm9hcmR8ZW58MHx8fHwxNzkyNDE4MDU3fDA&ixlib=rb-4.1.0&q=85",
    alt: "Precise per-second runtime meter and cost breakdown",
    iconColor: "text-[#22c55e]",
    icon: (
      <>
        <path d="M12 2v4"></path>
        <path d="M12 18v4"></path>
        <path d="M4.93 4.93l2.83 2.83"></path>
        <path d="M16.24 16.24l2.83 2.83"></path>
        <path d="M2 12h4"></path>
        <path d="M18 12h4"></path>
        <path d="M4.93 19.07l2.83-2.83"></path>
        <path d="M16.24 7.76l2.83-2.83"></path>
      </>
    ),
    title: "Pay Per Second",
    body: "Sleeping machines pause billing instantly until the next tool call wakes them.",
  },
];

export const Features = () => {
  return (
    <section id="features" data-testid="features-section" className="border-b border-[#1e293b]/50 py-24">
      <div className="mx-auto max-w-6xl px-6">
        <div className="rl-reveal mb-16">
          <h2 className="mb-4 text-3xl font-bold text-white md:text-4xl">
            Dedicated cloud hardware for unattended AI runs
          </h2>
          <p className="max-w-xl text-[#94a3b8]">
            Every agent gets an isolated kernel, low latency storage, and
            automatic sleeping states.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {FEATURES.map((feature) => (
            <div
              key={feature.testid}
              data-testid={feature.testid}
              className="rl-reveal flex flex-col justify-between rounded-xl border border-[#1e293b] bg-[#0c121b] p-6 transition-colors hover:border-[#22d3ee]/40"
            >
              <div className="relative mb-6 h-32 overflow-hidden rounded-lg border border-[#1e293b]">
                <img
                  src={feature.image}
                  alt={feature.alt}
                  loading="lazy"
                  className="h-full w-full object-cover opacity-70"
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-[#090e17]/90 via-[#090e17]/40 to-transparent"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <svg
                    className={`h-12 w-12 ${feature.iconColor}`}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    {feature.icon}
                  </svg>
                </div>
              </div>
              <div>
                <h3 className="mb-2 text-lg font-semibold text-white">{feature.title}</h3>
                <p className="text-sm text-[#94a3b8]">{feature.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
